export default {
  checklistItems: [],
  checklistItem: undefined,
};
